// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IPromoPopupSchema } from './PromoPopupSchema';

export interface IPromoSearchItemSchema {
  /** Действительна до **/
  activeDateToText: string;
  /** Ставка, проценты **/
  interestRate?: number | null;
  /** Ставка, в текстовом виде **/
  interestRateText?: string | null;
  /** Акция Черной Пятницы **/
  isBlackFriday: boolean;
  /** Льготная ипотека **/
  isDiscountMortgage: boolean;
  /** Эксклюзивная акция на ЦИАН **/
  isExclusive: boolean;
  /** Акция от представителя застройщика **/
  isFromSeller: boolean;
  /** Макс сумма кредита **/
  maxCredit?: number | null;
  /** Макс сумма кредита, в текстовом виде **/
  maxCreditText?: string | null;
  /** Максимальный срок кредита в годах **/
  maxLoanTerm?: number | null;
  /** Минимальный процент первоначального взноса **/
  minInitialPaymentRate?: number | null;
  /** Минимальный процент первоначального взноса, в текстовом виде **/
  minInitialPaymentRateText?: string | null;
  /** В скольких ЖК проходит акция **/
  newbuildingCountText: string;
  /** Название акции **/
  promoName: string;
  /** Данные для подробной информации по акции в попапе **/
  promoPopup: IPromoPopupSchema;
  /** Тип акции **/
  promoType: EPromoType;
  /** Тип акции (текстом) **/
  promoTypeText: string;
  /** Id автора акции **/
  providerId?: number | null;
  /** Лого автора акции **/
  providerLogo: string;
  /** Название автора акции (застройщика или банка) **/
  providerName: string;
  /** Id акции на стороне провайдера(может повторяться) **/
  providerPromoId: number;
  /** Поставщик акции **/
  providerType: EProviderType;
  /** Id пользователя, владельца акции **/
  realtyUserId?: number | null;
  /** id акции **/
  uniquePromoId: string;
}
export enum EPromoType {
  /** Бонусы **/
  'Bonus' = 'bonus',
  /** Циан ипотека **/
  'CianMortgage' = 'cianMortgage',
  /** Скидки **/
  'Discount' = 'discount',
  /** Материнский капитал **/
  'MaternalCapital' = 'maternalCapital',
  /** Военная ипотека **/
  'Military' = 'military',
  /** Ипотека **/
  'Mortgage' = 'mortgage',
}
export enum EProviderType {
  /** Автосгенеренная акция **/
  'Autogen' = 'autogen',
  /** Банк **/
  'Bank' = 'bank',
  /** Застройщик **/
  'Builder' = 'builder',
}
